import {
  isAnyBuyAndSellCategory,
  isAnyCommunityCategory,
  isAnyJobsCategory,
  isAnyPetsCategory,
  isAnyServicesCategory,
  isAnyVacationRentalsCategory,
} from '@kijiji/category'

export const shouldAllowGridView = (categoryId: number) => {
  return (
    isAnyBuyAndSellCategory(categoryId) ||
    isAnyJobsCategory(categoryId) ||
    isAnyServicesCategory(categoryId) ||
    isAnyCommunityCategory(categoryId) ||
    isAnyPetsCategory(categoryId) ||
    isAnyVacationRentalsCategory(categoryId)
  )
}
